/*! systematica - built 2026-10-09T14:03:56.432Z */
;
/* js/people/_filterview.js */
(function($) {
  $(document).ready(function(){
    var trigger =  $('.visualisation-filter');
    var target = $('.people-list');
    target.attr('data-visualisation', 'grid');

    trigger.on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      $(this).addClass('active');
      trigger.not(this).removeClass('active');
      var data = $(this).attr('data-visualisation');
      target.attr('data-visualisation', data);
      return false;
    })
  });
}(jQuery))

